"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[MeetingSessionCredentials]] includes the credentials used to authenticate
 * the attendee on the meeting
 */

var MeetingSessionCredentials = /*#__PURE__*/function () {
  function MeetingSessionCredentials() {
    _classCallCheck(this, MeetingSessionCredentials);

    /**
     * The attendee id for these credentials.
     */
    this.attendeeId = null;
    /**
     * The external user id associated with the attendee.
     */

    this.externalUserId = null;
    /**
     * If set, the session will be authenticated with a join token.
     */

    this.joinToken = null;
  }
  /**
   * Overrides JSON serialization so that join token is redacted.
   */


  _createClass(MeetingSessionCredentials, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        attendeeId: this.attendeeId,
        joinToken: this.joinToken === null ? null : '<redacted>'
      };
    }
  }]);

  return MeetingSessionCredentials;
}();

exports.default = MeetingSessionCredentials;